
import { HttpAttachmentModelList } from "@/service/ucadm";
import TableList from "@components/templates/tablelist";
import mixin from '../mixin'
export default {
    mixins: [TableList, mixin],
    data() {
        return {
            isMixin: true,
            Tools: { show: true },
            Searchs: {
                show: true,
                labelWidth: 90,
            },
        }
    },
    methods: {
        ajaxRequest: HttpAttachmentModelList,
        // 操作下的列表展示内容
        getOperateNodeMap(row) {
            const { id } = row
            return [{
                label: '编辑',
                show: true,
                to: {
                    name: 'attachmentmodelUpdate',
                    params: { type: 'edit' },
                    query: { id },
                },
            }
            ]
        },
    },
    computed: {
        ToolsData() {
            return [
                {
                    label: '添加',
                    theme: 'primary',
                    to: {
                        name: 'attachmentmodelUpdate',
                        params: { type: 'add' },
                    }
                },
            ]
        },
        SearchsData() {
            return [
                {
                    label: '名称',
                    key: 'CN_title',
                    tag: 'vInput',
                    show: true,
                },
            ]
        },
        columns() {
            return [
                {
                    title: '操作',
                    width: 110,
                    render: this.getOperateNodes
                },
                {
                    title: '名称',
                    key: 'title',
                },
                {
                    title: 'Code',
                    key: 'code',
                },
                {
                    title: '描述',
                    key: 'remark',
                },
                {
                    title: '创建时间',
                    key: 'createdAt',
                }, {
                    title: '更新时间',
                    key: 'updatedAt',
                }]
        },
    },
}




